import { LoginSeliseLogo } from '../login-selise-logo';

export const LoginBrandLogo = () => {
  return <LoginSeliseLogo />;
};
